import withEntity from '@/entity/components/with-entity';

import DocumentFieldset from './document-fieldset';

export default withEntity(DocumentFieldset);
